import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/library/icons/nature-ecology-leaf.svg
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 256 256"
};
function render(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", { d: "M223.45 40.07a8 8 0 0 0-7.52-7.52C139.8 28.08 78.82 51 52.82 94a87.1 87.1 0 0 0-12.76 49c.57 15.92 5.21 32 13.79 47.85l-19.51 19.5a8 8 0 0 0 11.32 11.32l19.5-19.51C81 210.73 97.09 215.37 113 215.94q1.67.06 3.33.06A86.93 86.93 0 0 0 162 203.18c43-26 65.93-86.97 61.45-163.11m-69.7 149.43c-22.75 13.78-49.68 14-76.71.77l88.63-88.62a8 8 0 0 0-11.32-11.32L65.73 179c-13.19-27-13-54 .77-76.71 22.09-36.47 74.6-56.44 141.31-54.06 2.39 66.66-17.59 119.18-54.06 141.27" }, null, -1)])]);
}
var nature_ecology_leaf_default = { render };
//#endregion
export { nature_ecology_leaf_default as default, render };

//# sourceMappingURL=nature-ecology-leaf.svg.js.map